<template>
  <div class="hist">
    <div class="hist-warp">
      <div class="csgo-back-title">
        <h5 @click="goLucky">幸运饰品</h5>
        >
        <h6>获得饰品历史</h6>
      </div>
      <div class="hist-list csgo-tabs">
        <el-tabs type="border-card" v-model="activeName" @tab-click="getTab" style="margin-bottom: 20px;">
          <el-tab-pane label="所有记录" name="one">
          </el-tab-pane>
          <el-tab-pane label="我的记录" name="two">
          </el-tab-pane>
        </el-tabs>
        <div class="csgo-table">
          <el-table :data="list" style="width: 100%">
            <el-table-column prop="time" label="时间" width="180">
            </el-table-column>
            <!-- <el-table-column prop="name" label="编号" width="180">
            </el-table-column> -->
            <el-table-column prop="name" label="玩家"> </el-table-column>
            <el-table-column label="盲盒信息" prop="skins"></el-table-column>
            <el-table-column prop="price" label="总额"> </el-table-column>
            <el-table-column prop="status" label="状态"> </el-table-column>
          </el-table>
        </div>
        <div class="csgo-page">
          <el-pagination background layout="prev, pager, next" :total="searchForm.totalSize" :page-size="searchForm.limit" @current-change="currentChange">
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="commonBg"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "one",
      searchForm: {
        page: 1,
        totalSize: 0,
        limit: 20,
      },
      list: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getTab(tab) {
      this.searchForm.page = 1
      this.list = []
      this.getList()
    },
    getList() {
      this.$doGet(this.activeName === 'one' ? '/api/hall.LuckySkin/history' : '/api/hall.LuckySkin/myHistory', this.searchForm).then((res) => {
        this.searchForm.totalSize = res.data.count
        this.list = res.data.list
      }).catch(() => { })
    },
    //分页 所有记录
    currentChange(value) {
      this.searchForm.page = value
      this.getList();
    },
    goLucky() {
      this.$router.push({
        path: `/lucky`,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.hist {
  .hist-warp {
    padding: 16px;
  }
  .csgo-tabs {
    /deep/ .el-tabs__content {
      padding: 0;
    }
  }
  //tabs
  .hist-list {
    margin-top: 20px;
    .csgo-table {
      background-color: #2b2c37;
      padding: 15px;
    }
  }
}
</style>